// import {ValidationEngine} from 'aurelia-validatejs';

// export class ValidationObserver {
//     constructor(model) {
// 				this.errors = [];
// 		    this.reporter = ValidationEngine.getValidationReporter(model);
// 		    this.subscriber = this.reporter.subscribe(result => {
// 						this.renderErrors(result);
// 				});
//     }

// 		hasErrors() {
// 				return !!this.errors.length;
// 		}

// 		renderErrors(result) {
// 				this.errors.splice(0, this.errors.length);
// 				result.forEach(error => {
// 						this.errors.push(error)
// 				});
// 		}

// 		dispose() {
// 			this.subscriber.dispose();
// 		}
// }
